module.exports = __webpack_public_path__ + "static/media/medal-gold-v2.3d8d6b20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultHeader/assets/medals/medal-gold-v2.svg
// module id = 1221
// module chunks = 0